import React, { useState } from "react";
import { Form, Input, Button, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
// import { forgotpassword } from "../../actions/loginAction";
import { forgotPassword } from "../../reducers/forgotPassword";
import { useNavigate, Navigate } from "react-router-dom";
import { resetLogin } from "../../services/AuthServices";
import Alert from "../../components/common/alert";
import "../../components/basic/login/login.css";

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Title } = Typography;

  const auth = useSelector((state) => state.auth);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleClick = () => {
    navigate("/register");
  };

  const handleLoginClick = () => {
    navigate("/");
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const response = await resetLogin(
        values.email,
        `${window.location.origin}/#/reset-password`
      );

      if (response.data.success) {
        dispatch(forgotPassword(response.data.user));
        Alert("success", "Success!", response.data.message);
        setIsLoggedIn(true);
      } else {
        Alert(
          "error",
          "Error!",
          response.data.message.replaceAll("TRAINER", "TEACHER")
        );
      }
    } catch (error) {
      const message = error.response
        ? error.response.data.message
        : error.message;
      Alert("error", "Error!", message);
    }
  };

  if (isLoggedIn && auth?.userOptions?.[0]?.link) {
    return <Navigate to={auth.userOptions[0].link} replace />;
  }

  return (
    <div className="login-container">
      <div className="login-student-inner">
        <div className="space-btw">
          <Button className="login-btn" ghost onClick={handleLoginClick}>
            Sign In
          </Button>
          <Button className="register-btn" ghost onClick={handleClick}>
            Register
          </Button>
        </div>
        <div className="login-log">
          <img src="/assets/leagueonlinelogo2.png" alt="logo" width={"30%"} />
        </div>
        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <div style={{ display: "flex", gap: 12, flexDirection: "column" }}>
            <div>
              <Title style={{ color: "white", fontSize: "30px", fontWeight: 400 }} level={4}>
                Forgot your password?
              </Title>
              <Title
                style={{
                  color: "white",
                  fontSize: "20px",
                  fontWeight: 400,
                  textAlign: "start",
                }}
              >
                Please enter the email used to sign up with. Information to reset your password will be sent to the email.
              </Title>
            </div>

            <div style={{ display: "flex", gap: 24, flexDirection: "column" }}>
              <Form.Item
                name="email"
                label={<span style={{ color: "white" }}>Enter email address</span>}
                colon={false}
                hasFeedback
                rules={[
                  { type: "email", message: "The input is not valid E-mail!" },
                  { required: true, message: "Please input your E-mail!" },
                ]}
              >
                <Input placeholder="Email" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Request reset link
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPassword;
